import { Calendar, Clock, MapPin } from "lucide-react";

export const upcomingHolidays = [
  { name: "October Half Term 2026", dates: "Tue 20, Wed 21, Thu 22 Oct & Mon 26 – Fri 30 Oct", status: "Few places left" },
  { name: "Christmas 2026", dates: "16, 17, 18, 21, 22, 23 Dec" },
  { name: "February Half Term 2027", dates: "15 – 19 Feb" },
  { name: "Easter 2027", dates: "29 Mar – 2 Apr & 5 – 9 Apr" },
  { name: "May Half Term 2027", dates: "1 – 4 Jun" },
  { name: "Summer 2027", dates: "14, 15, 16 Jul & 19 Jul – 20 Aug" },
];

export default function TimetableSection() {
  return (
    <section
      id="timetable"
      className="py-20 bg-white"
      data-testid="timetable-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#D4A857]/10 text-[#D4A857] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-4 font-['Montserrat']">
            <Calendar size={16} />
            Plan Ahead
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A1A2F] mb-4 font-['Montserrat']">
            Upcoming Holiday <span className="text-[#D4A857]">Dates</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto font-['Lato']">
            Your 5-Day Pass works across ALL these holiday periods. Choose any 5 days that suit your family!
          </p>
        </div>

        {/* Session Info */}
        <div className="flex flex-wrap justify-center gap-4 mb-10">
          <div className="flex items-center gap-2 bg-[#0A1A2F] text-white px-4 py-2 rounded">
            <Clock size={18} />
            <span className="font-medium font-['Lato']">Sessions: 9:30am - 4:30pm</span>
          </div>
          <div className="flex items-center gap-2 bg-[#0A1A2F] text-white px-4 py-2 rounded">
            <MapPin size={18} />
            <span className="font-medium font-['Lato']">Dedicated fencing venue, Barnet EN5 4DJ</span>
          </div>
        </div>

        {/* Holiday Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {upcomingHolidays.map((holiday, i) => (
            <div
              key={i}
              className="bg-white rounded-lg border-2 border-[#F4F4F4] hover:border-[#D4A857] hover:shadow-lg transition-all p-5 group"
              data-testid={`holiday-${i}`}
            >
              <div className="flex justify-between items-start mb-3">
                <h3 className="font-bold text-[#0A1A2F] group-hover:text-[#D4A857] transition-colors font-['Montserrat']">
                  {holiday.name}
                </h3>
                <Calendar className="text-[#D4A857] opacity-50 group-hover:opacity-100 transition-opacity" size={20} />
              </div>
              <p className="text-[#D4A857] font-semibold font-['Montserrat']" data-testid={`holiday-dates-${i}`}>{holiday.dates}</p>
              {holiday.status && (
                <span className="inline-block mt-3 bg-[#C8102E] text-white text-xs font-bold uppercase tracking-wide px-3 py-1 rounded font-['Montserrat']" data-testid={`holiday-status-${i}`}>
                  {holiday.status}
                </span>
              )}
              {holiday.provisional && (
                <p className="text-gray-500 text-xs mt-2 font-['Lato']" data-testid={`holiday-provisional-${i}`}>Provisional — dates to be confirmed</p>
              )}
            </div>
          ))}
        </div>

        {/* Flexibility Note */}
        <div className="bg-[#0A1A2F] rounded-lg p-8 text-white relative overflow-hidden">
          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <p className="text-[#D4A857] font-bold mb-2 uppercase tracking-wide text-sm font-['Montserrat']">Maximum Flexibility</p>
            <p className="text-2xl font-bold mb-4 font-['Montserrat']">
              "You can attend any 5 sessions during school holidays within 12 months of purchase. 
              Choose your days as you go."
            </p>
            <p className="text-white/80 font-['Lato']">
              Example: 1 day at February Half Term + 2 days at Easter + 2 days in Summer. 
              Or all 5 days in one holiday. It's completely up to you!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
